import { render, staticRenderFns } from "./CusPageComplianceManage.vue?vue&type=template&id=7f8a38e4&scoped=true&"
import script from "./CusPageComplianceManage.vue?vue&type=script&lang=js&"
export * from "./CusPageComplianceManage.vue?vue&type=script&lang=js&"
import style0 from "./CusPageComplianceManage.vue?vue&type=style&index=0&id=7f8a38e4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f8a38e4",
  null
  
)

export default component.exports